import React from 'react';
import { Flex, Heading, IconButton, Icon } from '@chakra-ui/react';
import { useNavigate, To } from 'react-router-dom';
import { IconType } from 'react-icons';

interface HeaderProps {
  title: string;
  leftIcon?: IconType;
  rightIcon?: IconType;
  leftTo?: To | number;
  rightTo?: To | number;
}

const Header = ({
  title,
  leftIcon,
  leftTo,
  rightIcon,
  rightTo,
}: HeaderProps) => {
  const navigate = useNavigate();

  return (
    <Flex
      bg="white"
      py="12px"
      zIndex={8}
      alignSelf="stretch"
      justifyContent="space-between"
      alignItems="center"
    >
      <IconButton
        disabled={!!leftIcon}
        opacity={leftIcon ? 1 : 0}
        onClick={() => leftTo && navigate(leftTo as To)}
        border="none"
        boxSize="24px"
        background="none"
        size="xs"
        variant="outline"
        aria-label="left-icon"
        icon={<Icon boxSize="24px" as={leftIcon} />}
      />
      <Heading
        as="h2"
        fontSize="18px"
        lineHeight="tall"
        textAlign="center"
        noOfLines={1}
      >
        {title}
      </Heading>
      <IconButton
        disabled={!!rightIcon}
        opacity={rightIcon ? 1 : 0}
        background="none"
        borderRadius="50%"
        border="none"
        boxSize="24px"
        size="xs"
        variant="outline"
        onClick={() => rightTo && navigate(rightTo as To)}
        aria-label="right-icon"
        icon={<Icon boxSize="24px" as={rightIcon} />}
      />
    </Flex>
  );
};

export default Header;
